import { FC } from 'react';

import LogoImageUS from './svg/logo-us.svg?react';
import LogoImageCanada from './svg/logo-ca.svg?react';

type Props = {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  country?: 'US' | 'CA' | string;
};

const Logo: FC<Props> = ({ size = 'sm', country = 'US' }) => {
  const width = {
    xs: '120',
    sm: '165',
    md: '215',
    lg: '360',
  }[size];

  const height = {
    xs: '23',
    sm: '32',
    md: '42',
    lg: '66',
  }[size];

  return country === 'CA' ? (
    <LogoImageCanada width={width} height={height} alt="DiscountMags.ca" />
  ) : (
    <LogoImageUS width={width} height={height} alt="DiscountMags.com" />
  );
};

export default Logo;
